import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { useFormContext, get, Controller } from "react-hook-form";
import Tooltip from './Tooltip';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './Datepicker.css';
import { DaysType } from '../Types';
import { isValidHandoverDate } from '../DateUtils';

type DateFieldProps = {
    name: string;
    label?: string;
    className?: string;
    disabled?: boolean;
    tooltipBody?: () => JSX.Element;
    required?: boolean;
    selectsStart?: boolean;
    selectsEnd?: boolean;
    dates?: Date[];
    minDate: Date;
    maxDate?: Date;
    daysAllowed?: DaysType[];
    bankHolidays?: string[];
    datesUpdater?: (dates: Date[]) => void;
}

function DateField({ className, label, name, disabled, tooltipBody, required, selectsStart, selectsEnd, minDate, maxDate, dates, daysAllowed, bankHolidays, datesUpdater }: DateFieldProps) {
    const { formState: { errors }, control  } = useFormContext();
    const error = get(errors, name);

    const validations = {
        required: required
    };

    const handleChange = (field: any, date: Date | null) => {
        if (date) {
            field.onChange(date);
            if (dates) {
                const updatedDates = [...dates];
                updatedDates[selectsStart ? 0 : 1] = date;
                datesUpdater && datesUpdater(updatedDates);
            }

        }
    }

    const filterDates = (date: Date): boolean => {
        return isValidHandoverDate(date, bankHolidays);        
    }

  

    return (
        <FormGroup>
            {label && <Label htmlFor={name}>{label}</Label>}
            {tooltipBody && 
                <Tooltip tooltipBody={tooltipBody()} />
            }
            <Controller
                control={control}
                name={name}
                rules={validations}
                shouldUnregister={true}
                render={({ field }) => (
                    <DatePicker
                        className={"form-control " + className}
                        placeholderText={"Select Date"}
                        onChange={(date) => handleChange(field, date)}
                        selected={field.value}
                        disabled={disabled}
                        dateFormat="dd/MM/yyyy"
                        dropdownMode="select"
                        selectsStart={selectsStart}
                        selectsEnd={selectsEnd}
                        startDate={dates && dates[0]}
                        endDate={dates && dates[1]}
                        minDate={minDate}
                        maxDate={maxDate}
                        filterDate={(d) => filterDates(d)}
                        yearDropdownItemNumber={15}
                        showMonthDropdown
                        showYearDropdown
                    />
                )}
            />
            <div className="form-error-wrapper">
                {error?.type === 'required' && 'This is a required field'}
                {error?.type === 'pattern' && 'This is not valid'}
            </div>
        </FormGroup>

        
    );
}
export default DateField;
